import { COMMON_QUERY_CONFIG, COMMON_QUERY_RULES_CONFIG } from './shared/configs';

enum SECTION_ENUM {
  MAGAZINE = 'Magazine',
  MAGAZINE_COVER = 'Magazine Cover'
}

const MAGAZINE = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? []), { term: { key: 'ContentType', value: 'article' } }],
    or: [{ terms: { key: 'BarronsDisplayBrand', value: ['BARFEATURE'] } }],
    not: COMMON_QUERY_RULES_CONFIG.not
  }
};

const MAGAZINE_COVER = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? []), { term: { key: 'ContentType', value: 'article' } }],
    or: [{ terms: { key: 'BarronsDisplayBrand', value: ['BARCOVER'] } }],
    not: COMMON_QUERY_RULES_CONFIG.not
  }
};

export { SECTION_ENUM, MAGAZINE, MAGAZINE_COVER };
